import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";

import { BsXLg, BsFillFileEarmarkFill, BsFillFileEarmarkTextFill, BsFillChatFill, BsFillChatTextFill } from "react-icons/bs";

import Modal from "react-bootstrap/Modal";

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Dialog from "./Dialog.js";
import ImpactList from "./ImpactList.js";
import SolutionTitle from "./SolutionTitle.js";


export default function Report (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    function endTheme ()
    {
	gDispatch({ type: "endRealTime" });
	gDispatch({ type: "closeReport" });
	gDispatch({ type: "closeDialogue" });
	gDispatch({ type: "openEnd", themeId: gData.state.currentThemeId });
    }

    
    const [showEndDialog, setShowEndDialog] = useState(false);

    const themeId = gData.state.currentThemeId;
    const waitingSolutionIds = Object.values(gData.state.solutions)
				     .filter((waitingSolution) => {
					 const waitingSolutionContent = gData.content.solutions[waitingSolution.id];
					 return waitingSolutionContent.themeId === themeId && waitingSolution.applied === null;
				     })
				     .map((solution) => solution.id);

    const endDialog = (
	<Dialog show={showEndDialog} hide={() => setShowEndDialog(false)} confirm={endTheme} title="Remettre le rapport ?">
	    <p>Attention : il ne sera plus possible de modifier votre rapport. Vous vous apprêtez à terminer la mission&nbsp;!</p>
	    {waitingSolutionIds.length > 0 && (
		<>
		    <p>En particulier, les solutions suivantes seront automatiquement rejetées&nbsp;:</p>
		    <div className="d-flex flex-wrap justify-content-center gap-2">{waitingSolutionIds.map((waitingSolutionId) => (<SolutionTitle key={waitingSolutionId} solutionId={waitingSolutionId}/>))}</div>

		</>
	    )}
	</Dialog>
    );

    // FUNCTIONS

    function closeReport () { gDispatch({ type: "closeReport" }); }

    function openAnalysis (solutionId)
    {
	//gDispatch({ type: "closeReport" });
	gDispatch({ type: "openAnalysis", solutionId });
    }
    
    function openApplication (solutionId)
    {
	//gDispatch({ type: "closeReport" });
	gDispatch({ type: "openApplication", solutionId });
    }

    const solutionCards = Object
	.entries(gData.state.solutions)
	.filter(([id, solution]) => gData.content.solutions[solution.id].themeId === gData.state.currentThemeId )
	.sort(([id1, solution1], [id2, solution2]) => {
	    if (solution1.found && solution2.found) return solution1.time - solution2.time;
	    else if (solution1.found) return -1;
	    else if (solution2.found) return +1;
	    else return 0;
	})
	.map(([id, solution]) => {
	    /* const investItems = Object
	       .entries(gData.state.documents)
	       .filter(([documentId, document]) => {
	       const documentContent = gData.content.documents[documentId];
	       return documentContent.solutionId === solution.id && documentContent.variableId === null
	       })
	       .map(([documentId, document]) => {
	       docNb++;
	       if (document.found) { foundNb++; return (<BsFillClipboard2DataFill key={documentId} className="fs-3"/>); }
	       return (<BsFillClipboard2Fill key={documentId} className="fs-3 opacity-50"/>);
	       }); */
	    
	    const documentItems = Object
		.entries(gData.state.documents)
		.filter(([id, document]) => {
		    const documentContent = gData.content.documents[document.id];
		    return documentContent.solutionId === solution.id && documentContent.type === "document"; //&& documentContent.variableId !== null
		})
		.map(([id, document]) => {
		    if (document.found) { return (<BsFillFileEarmarkTextFill key={document.id} className="fs-3"/>); }
		    return (<BsFillFileEarmarkFill key={document.id} className="fs-3 opacity-50"/>);
		});
	    
	    const adviceItems = Object
		.entries(gData.state.documents)
		.filter(([id, document]) => {
		    const documentContent = gData.content.documents[document.id];
		    return documentContent.solutionId === solution.id && documentContent.type === "advice" && documentContent.variableId !== null
		})
		.map(([id, document]) => {
		    if (document.found) { return (<BsFillChatTextFill key={document.id} className="ms-1 fs-3"/>); }
		    return (<BsFillChatFill key={document.id} className="ms-1 fs-3 opacity-50"/>);
		});

	    const result = gData.state.reports[solution.id].result;
	    const solutionFound = solution.found;
	    const analysisDone = result !== null;
	    const applicationDone = solution.applied !== null;
	    const showAnalysis = solutionFound && (gData.state.vars.allowAnalysis === undefined || gData.state.vars.allowAnalysis);
	    const showApplication = analysisDone && !applicationDone && (gData.state.vars.allowApplication === undefined || gData.state.vars.allowApplication);
	    
	    //active={false && gData.state.currentSolutionId === solution.id}
	    return (
		<Card className="card-lg shadow" key={solution.id}>
		    <Card.Header className="d-flex justify-content-between align-items-stretch">
			<SolutionTitle solutionId={solution.id} size="md"/>
			{/* <div className="d-flex gap-1">
			    {analysisDone && (<ReliabilityBadge solutionId={solution.id}/>)}
			    {applicationDone && (<ApplicationBadge solutionId={solution.id}/>)}
			    </div> */}
		    </Card.Header>

		    <Card.Body>
			<Row>
			    <Col md={6} className="d-flex flex-column align-items-center gap-2">
				<div className="text-uppercase fs-6 fw-medium">Documents collectés</div>
				<div className="d-flex gap-0 justify-content-start">
				    {/* {investItems} */}
				    {documentItems}
				    {adviceItems}
				</div>
				<div className="mt-4 d-flex flex-column align-items-stretch gap-2">
				    {(showAnalysis) && (<Button disabled={false} onClick={() => openAnalysis(solution.id)}>{result === null ? "Analyser les documents" : "Voir l'analyse"}</Button>)}
				    {(showApplication) && (<Button disabled={false} onClick={() => openApplication(solution.id)}>Prendre une décision</Button>)}
				</div>
			    </Col>
			    
			    <Col md={6} className="d-flex flex-column align-items-center gap-2">
				{analysisDone && (
				    <>
					<div className="text-uppercase fs-6 fw-medium">Impacts estimés</div>
					<ImpactList solutionId={solution.id} type="analysis"/>
				    </>
				)}
			    </Col>
			</Row>
		    </Card.Body>
		</Card>
	    );
	});


    const showEnd = (gData.state.vars.allowApplication === undefined || gData.state.vars.allowApplication);

    return (
	<>
	    <Modal
		dialogClassName="modal-xxl"
				 contentClassName="modal-content-xxl"
				 show={gData.state.showModals.report}
				 onHide={closeReport}
				 scrollable={true}
				 centered
	    >
		<Modal.Header className="d-flex align-items-center justify-content-between bg-light">
		    <Modal.Title className="text-uppercase">Rapport de mission</Modal.Title>
		    <div className="d-flex gap-2">
			{showEnd && (<Button variant="primary" onClick={() => setShowEndDialog(true)}>Remettre le rapport</Button>)}
			<Button variant="secondary" onClick={closeReport}><BsXLg/></Button>
		    </div>
		</Modal.Header>
		<Modal.Body>
		    <div className="mt-4 mb-5 gap-4 d-flex flex-wrap justify-content-center align-items-start">
			{solutionCards}
		    </div>
		</Modal.Body>
	    </Modal>
	    {endDialog}
	</>
    );
}
